export default errorMessage => {
  if (errorMessage) {
    if (errorMessage.includes('MRS')) return 'mrs'
    return 'internet'
  } else return 'os'
}
